import React from 'react';
import API from "@beardeddevops/react.api";

import Framework from "@beardeddevops/react.framework"
import {Parts} from "components";
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import UserRoles from "../../../../../constants/UserRoles";
import ScheduleComponent from "../../../../../components/Parts/ScheduleComponent";
import Types from "../../../../../constants/Types";
import {Button} from "reactstrap";
import APPCONFIG from "../../../../../constants/Config";
import ScheduleApprovalsComponent from "../../../../../components/Collections/ScheduleApprovals";


const breadcrumbStatic = [{
	name: 'Set Schedule',
	url: '/schedule_approvals/self',
	icon: 'dashboard'
}];

export default class Approve_Self extends Framework.Components.View {

	constructor(props) {
		super(props);
	}
	render() {
		let {match, history, baseUrl, roles, user, initialDate = null} = this.props;

		return (
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbStatic} history={history}/>

				<ScheduleApprovalsComponent history={history} id={user} initialDate={initialDate}/>
			</div>
		)
	}
};
